<template>
  <v-app>
    <main-menu></main-menu>
    <main-toolbar></main-toolbar>
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <create-join-dialog v-if="showCreateJoinDialog"
                        v-model="showCreateJoinDialog"></create-join-dialog>
    <create-payment-dialog v-if="showCreatePaymentDialog"
                           v-model="showCreatePaymentDialog"></create-payment-dialog>
    <bp-level-progress-popup v-if="showBpLevelProgressDialog"
                             v-model="showBpLevelProgressDialog"></bp-level-progress-popup>
    <use-terms-dialog v-if="showUseTermsDialog"
                           v-model="showUseTermsDialog"></use-terms-dialog>
    <v-snackbar v-model="snackInfo" top right color="info">
      {{ snackInfoMessage }}
    </v-snackbar>
    <v-snackbar v-model="snackError" top right color="error">
      {{ snackErrorMessage }}
    </v-snackbar>
  </v-app>
</template>

<script>
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { mapGetters, mapMutations } from 'vuex';
import MainMenu from './components/MainMenu.vue';
import MainToolbar from './components/MainToolbar.vue';
import UseTermsDialog from './components/user/UseTermsDialog.vue';
import CreateJoinDialog from './components/user/CreateJoinDialog.vue';
import CreatePaymentDialog from './components/user/CreatePaymentDialog.vue';
import '@mdi/font/css/materialdesignicons.css';
import Account from './api/Account';
import UI from './api/UI';
import BpLevelProgressPopup from '@/components/user/BpLevelProgressPopup.vue';

export default {
  name: 'App',
  components: {
    BpLevelProgressPopup,
    CreateJoinDialog,
    MainToolbar,
    MainMenu,
    CreatePaymentDialog,
    UseTermsDialog,
  },
  data: () => ({}),
  computed: {
    snackInfo: {
      get() {
        return !!this.snackInfoMessage;
      },
      set() {
        this.setSnackInfoMessage(null);
      },
    },
    snackError: {
      get() {
        return !!this.snackErrorMessage;
      },
      set() {
        this.setSnackErrorMessage(null);
      },
    },
    showCreateJoinDialog: {
      get() {
        return this.createJoinDialog;
      },
      set(value) {
        this.$store.commit('setCreateJoinDialog', value);
      },
    },
    showBpLevelProgressDialog: {
      get() {
        return this.bpProgressDialog;
      },
      set(value) {
        this.$store.commit('setBpProgressDialog', value);
      },
    },
    showCreatePaymentDialog: {
      get() {
        return this.createPaymentDialog;
      },
      set(value) {
        this.$store.commit('setCreatePaymentDialog', value);
      },
    },
    showUseTermsDialog: {
      get() {
        return this.useTermsDialog;
      },
      set(value) {
        this.$store.commit('setUseTermsDialog', value);
      },
    },
    ...mapGetters(['bpProgressDialog', 'createPaymentDialog', 'useTermsDialog', 'createJoinDialog', 'snackInfoMessage', 'snackErrorMessage', 'lang']),
  },
  methods: {
    async initializeYandexMetrika(counter) {
      // Cтандартный код от Яндекс
      /* eslint-disable */
      (function (m, e, t, r, i, k, a) {
        m[i] = m[i] || function () {
          (m[i].a = m[i].a || []).push(arguments);
        };
        m[i].l = 1 * new Date();
        k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
      })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

      ym(counter, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
      });
      /* eslint-enable */
    },
    async initializeGoogleAnalytics(counter) {
      const scriptTag = document.createElement('script');
      scriptTag.async = true;
      scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${counter}`;
      document.body.append(scriptTag);
      window.dataLayer = window.dataLayer || [];

      function gtag() {
        // eslint-disable-next-line
        window.dataLayer.push(arguments);
      }

      gtag('js', new Date());
      gtag('config', counter);
    },
    async loadUISettings() {
      try {
        const settings = await UI.getSettings();
        this.setUISettings(settings.data);
        this.$vuetify.lang.current = this.lang;
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.setAccountData({});
          await this.$router.replace('/notFound');
        }
      }
    },
    ...mapMutations(['setUISettings', 'setAccountData', 'setSnackInfoMessage', 'setSnackErrorMessage']),
  },
  mounted() {
    // Раз в час будем перезапрашивать сессию.
    setInterval(() => Account.refreshAuth(), 3600000);
  },
  async created() {
    await this.loadUISettings();

    if (this.$store.state.UISettings.yandexMetrikaCounter) {
      await this.initializeYandexMetrika(this.$store.state.UISettings.yandexMetrikaCounter);
    }
    if (this.$store.state.UISettings.googleAnalyticsCounter) {
      await this.initializeGoogleAnalytics(this.$store.state.UISettings.googleAnalyticsCounter);
    }
  },
};
</script>

<style lang="less">
  .logo {
    height: 120px;
  }

  .v-btn {
    letter-spacing: 0.01rem!important;
  }

  .show-scrollbar {
    &::-webkit-scrollbar {
      -webkit-appearance: none;
    }

    &::-webkit-scrollbar:vertical {
      width: 11px;
    }

    &::-webkit-scrollbar:horizontal {
      height: 11px;
    }

    &::-webkit-scrollbar-thumb {
      /*border-radius: 8px;*/
      border: 2px solid white;
      background-color: rgba(0, 0, 0, .5);
    }

    &.dialog-scroll {
      &::-webkit-scrollbar-thumb {
        border: 0;
      }

      &::-webkit-scrollbar:vertical {
        width: 5px;
      }
    }
  }

  img {
    max-width: 100%;
  }

  .ql-video-wrapper {
    iframe {
      width: 100% !important;
      height: 300px !important;
    }
  }

  .ql-align-center {
    text-align: center;
  }

  .ql-align-right {
    text-align: right;
  }

  .ql-editor {
    min-height: 200px;
    max-height: 200px;
    overflow-y: scroll;
    p {
      margin-bottom: 0 !important;
    }
  }

  .ql-read-only {
    .ql-toolbar {
      max-height: 0;
      overflow: hidden;
      border-bottom: 0;
      padding: 0;
    }
  }

  .help-text {
    margin-left: 5px;
    color: rgb(137, 137, 137);
    font-size: 12px;
  }

  .file-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
    word-break: break-all;
    .file-buttons {
      display: flex;
    }
    a {
      text-decoration: none;
    }
  }

  a.submenu-link {
    color: black !important;
    text-decoration: none;
    margin-right: 10px;
    font-weight: 300;

    &.active {
      font-weight: 400;
    }
  }

  .no-click {
    pointer-events: none
  }

</style>
